import { useEffect, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";
import { Panel } from "@/components/crm/Badges";

export const ContactBackfillPanel = ({ initial }) => {
  const [st, setSt] = useState(initial || { status: "idle", total: 0, processed: 0, updated: 0, failed: 0 });
  const running = st.running || st.status === "running";

  useEffect(() => {
    if (!running) return undefined;
    const t = setInterval(() => api.get("/admin/integrations/ghl/backfill").then((r) => setSt(r.data)).catch(() => {}), 3000);
    return () => clearInterval(t);
  }, [running]);

  const start = async () => {
    try {
      const { data } = await api.post("/admin/integrations/ghl/backfill");
      setSt(data);
      toast.success("Actualización de contactos iniciada");
    } catch (e) { toast.error(errorMessage(e)); }
  };
  const pct = st.total ? Math.round((st.processed / st.total) * 100) : 0;

  return (
    <Panel title="Datos de contactos" className="xl:col-span-3" testid="ghl-backfill-panel">
      <p className="text-sm text-slate-600">Completa nombre, correo, teléfono y foto de los leads que llegaron sin nombre ("Contacto" o "."). Nunca cambia nombres editados a mano.</p>
      <div className="mt-4 flex flex-wrap items-center gap-4">
        <Button onClick={start} disabled={running} className="rounded-xl bg-[#1E6FD9]" data-testid="ghl-backfill-button">
          {running ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <RefreshCw className="mr-1.5 h-4 w-4" />} Actualizar datos de contactos
        </Button>
        <span className="text-sm text-slate-600" data-testid="ghl-backfill-progress">
          {st.status === "idle" ? "Aún no se ha ejecutado"
            : `${st.processed} / ${st.total} revisados · ${st.updated} actualizados${st.failed ? ` · ${st.failed} con error` : ""}`}
          {st.status === "done" && st.finished_at && <span className="text-slate-400"> · terminado {fmtDateTime(st.finished_at)}</span>}
        </span>
      </div>
      {running && <Progress value={pct} className="mt-4 h-2" data-testid="ghl-backfill-bar" />}
    </Panel>
  );
};
